module.exports = __webpack_public_path__ + "static/media/student18.a1e88ee7.png";